<script>
  export default {
    props: {
      google: {
        type: Object,
        required: true
      },
      map: {
        type: Object,
        required: true
      },
      marker: {
        type: Object,
        required: true
      }
    },
    mounted() {

      const { Marker } = this.google.maps;
      let markerAux=new Marker({
        position: this.marker.position,
        marker: this.marker,
        map: this.map,
        draggable:false,
        title: this.marker.title,
        label: this.marker.label
      });
      // aca registramos el marker de google
      this.$store.dispatch('sGoogleMaps/addNewPosition', markerAux);
      // aca solo registramos la latitud y longitud
      this.$store.dispatch('sGoogleMaps/addNewPositionLocation', this.marker.position);

      const that=this;
      this.google.maps.event.addListener(this.map, 'click', e=>{
        console.log('se ha anadido el evento escucha')
      
        that.mCaptaPosicion(e.latLng);
        
      })
    },
    methods:{
      async mCaptaPosicion(latLng) {

            console.log('clickeando el nuevo punto')
            // console.log(`la posicion es ${latLng}`);
            let auxPosition=String(latLng);
            auxPosition=auxPosition.split(',');
            let latAux=parseFloat(auxPosition[0].replace('(', ''));
            let lngAux=parseFloat(auxPosition[1].replace(')', ''));
            let auxNewPosition={
              lat:latAux,
              lng:lngAux
            }

            // console.log(`la latitud es ${latAux} y la longitud es ${lngAux}`)
            // console.log(this.cGetLocation)
            // this.cGetLocation[0].setMap(null);

            const { Marker } = this.google.maps;
            let latlng = new google.maps.LatLng(latAux, lngAux);

            // obtenemos el ultimo valor del indice y sumamos uno
            let new_item=this.mGetLastItem();
            
            let marker=new Marker({
              position: latLng,
              map: this.map,
              draggable:false,
              title: `${new_item}`,
            });

            let caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHJKMNPQRTUVWXYZ2346789";
            let code=caracteres.charAt(Math.floor(Math.random()*caracteres.length)) + caracteres.charAt(Math.floor(Math.random()*caracteres.length))+new_item;
            let location={
              id:code,
              position:{lat:parseFloat(latAux), lng:parseFloat(lngAux)},
              title:`${code}`,              
              localidad:``,
              descripcion:``,
              edit:false
            }
            // aca registramos el marker de google
            this.$store.dispatch('sGoogleMaps/addNewMarkJurisdiccion', location);
            // aca registramos la latitud y longitud
            // this.$store.dispatch('sGoogleMaps/addNewPositionLocation', auxNewPosition);
            // return Promise.resolve(true);
      },
      mGetLastItem(){
        return this.cGetPositionsJurisdiccion.length;
      }
    },
    computed:{
      cGetLocation(){
        // return this.$store.getters.getLocation;
        // console.log(this.$store.getters['sGoogleMaps/getLocation'].lat);
        return this.$store.getters['sGoogleMaps/getLocation'];
      },
      cGetPositionsJurisdiccion(){
        return this.$store.getters['sGoogleMaps/getMarkersJurisdiccion'];
      }
    },
    render() {}
  };
</script>


// WEBPACK FOOTER //
// src/components/maps/NewMarkJurisdiccion.vue